import { Component } from '@verndale/core';
import { setLocalStorageData } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      links: this.el._$$('.footer__col-title'),
      utilityLanguage: this.el._$('.footer__utility-language-item'),
      dropDown: this.el._$('.footer__utility-language-dropdown'),
      footer: this.el._$('.footer__cols'),
      $utilityLanguageItems: this.el._$$(
        '.footer__utility-language-dropdown-item'
      )
    };

    this.linkItemsExpanded = 'footer-links__items--expanded';
    this.linkItems = 'footer-links__items';
    this.linkTitleExpanded = 'footer__utility-link-title--expanded';
    this.linkTitle = 'footer__utility-link-title';

    this.classes = {
      utilityOpen: 'footer__utility-language-dropdown-open'
    };

    this.setup();
  }

  addListeners() {
    this.dom.links._on('click', this.handleClick.bind(this));
    this.dom.utilityLanguage._on(
      'click',
      this.onToggleUtilityNavDropdown.bind(this)
    );
  }

  changeSelectedLanguageLabel() {
    if (!window.location.hostname.includes('.ca')) return;

    if (window.location.pathname.includes('/fr')) {
      this.dom.utilityLanguage.textContent = this.dom.$utilityLanguageItems
        .find(item => item._$('a').getAttribute('href').includes('/fr'))
        ._$('.link__label').textContent;
    } else {
      this.dom.utilityLanguage.textContent = this.dom.$utilityLanguageItems
        .find(item => item._$('a').getAttribute('href').includes('/en'))
        ._$('.link__label').textContent;
    }
  }

  setup() {
    if (this.dom.dropDown) {
      this.renderUtilityLanguageItems();
      this.changeSelectedLanguageLabel();
      this.addUtilityLanguageListener();
    }
  }

  renderUtilityLanguageItems() {
    const currentHost = window.location.host;

    const list = document.createElement('ul');
    list.role = 'menubar';
    list.classList.add('footer__utility-language-dropdown');

    const items = this.dom.$utilityLanguageItems
      .map((item, i) => {
        const link = item._$('a');
        const text = link._$('.link__label')?.textContent;
        const href = link?.href;
        let target = `${href}`;

        if (!text || !href) return '';

        if (!href.includes(currentHost)) {
          target = `${href}`;
        }

        return `
        <li class="footer__utility-language-dropdown-item">
          <a
            class="link link--small"
            href="${target}"
            data-href="${target}"
          >
            ${text}
          </a>
        </li>
      `;
      })
      .join('');

    list.innerHTML = items;
    this.dom.dropDown.replaceWith(list);
  }

  addUtilityLanguageListener() {
    this.dom.$utilityLanguageItems.forEach(item => {
      const link = item._$('a');
      const href = link?.dataset.href;

      link.addEventListener('click', () => {
        console.log(href, '< href');

        if (href.includes('fr')) {
          setLocalStorageData({ langPref: 'fr' });
        } else {
          setLocalStorageData({ langPref: 'en' });
        }

        window.location.replace(href);
      });
    });
  }

  handleClick(e) {
    if (this.dom.footer.offsetWidth <= 830) {
      e.preventDefault();
    }
    let childLink = e.currentTarget.parentNode.getElementsByClassName(
      'footer-links__items'
    )[0];
    if (
      e.currentTarget.parentNode.getElementsByClassName('footer-links__items')
        .length > 0
    ) {
      childLink.classList = [];
      childLink.classList.add(this.linkItemsExpanded);
      const titleLink = e.currentTarget.getElementsByClassName(
        this.linkTitle
      )[0];
      titleLink.classList.remove(this.linkTitle);
      titleLink.classList.add(this.linkTitleExpanded);
    } else {
      childLink = e.currentTarget.parentNode.getElementsByClassName(
        'footer-links__items--expanded'
      )[0];
      childLink.classList = [];
      childLink.classList.add(this.linkItems);
      const titleLink = e.currentTarget.getElementsByClassName(
        this.linkTitleExpanded
      )[0];
      titleLink.classList.remove(this.linkTitleExpanded);
      titleLink.classList.add(this.linkTitle);
    }
  }

  onToggleUtilityNavDropdown(e) {
    const dropdown = this.el._$('.footer__utility-language-dropdown');

    e.preventDefault();
    if (dropdown.classList.contains(this.classes.utilityOpen)) {
      dropdown.classList.remove(this.classes.utilityOpen);
      return;
    }
    dropdown.classList.remove(this.classes.utilityOpen);
    dropdown.classList.add(this.classes.utilityOpen);
  }
}

export default Module;
